import { render, staticRenderFns } from "./ChangePasswd.vue?vue&type=template&id=9e3804d4&scoped=true&"
import script from "./ChangePasswd.vue?vue&type=script&lang=js&"
export * from "./ChangePasswd.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/content.scss?vue&type=style&index=0&id=9e3804d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3804d4",
  null
  
)

export default component.exports